import React from 'react';
import SvgIcon from './svg-icon';

export default React.createClass({

	render() {
		return (
			<SvgIcon {...this.props}>
					<path d="M12,5c-3.866,0-7,3.134-7,7s3.134,7,7,7s7-3.134,7-7S15.866,5,12,5L12,5z M12,17.687c-3.142,0-5.688-2.546-5.688-5.688
		S8.859,6.312,12,6.312S17.687,8.858,17.687,12S15.141,17.687,12,17.687L12,17.687z"/>
					<path d="M14.188,8.501L12,10.688L9.813,8.501L8.501,9.813L10.688,12l-2.187,2.187l1.312,1.312L12,13.311l2.188,2.188l1.312-1.312
		L13.312,12L15.5,9.813L14.188,8.501z"/>
			</SvgIcon>
		);
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/svg-icons/close.js
 **/